import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IFooterAddress } from './footer.address.interface';

@Component({
    selector: 'mlp-ng-footer-address',
    templateUrl: './footer.address.component.html',
    styleUrls: ['./footer.address.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class FooterAddressSharedComponent {
    @Input() data: IFooterAddress;
}
